import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 270px;
    font-size: 16px;
    text-align: left;
    padding-bottom: 15px;
`;

export const User = styled.div`
    padding: 30px 32px;
    > div {
        overflow: hidden;
        text-overflow: ellipsis;

        &.email {
            font-size: 14px;
            margin-top: 7px;
            color: var(--color-body-text-300);
        }
    }
`;

export const ListItem = styled.li`
    text-align: left;
    border-top: 1px solid var(--color-border-500);

    svg {
        font-size: 18px;
        color: var(--color-text-300);
    }

    a {
        display: block;
        padding: 15px 30px;
        color: var(--color-text-500);

        &:hover {
            text-decoration: none;
            color: var(--color-primary-500);
        }
    }
`;
